const CompleteType = {
    WAITLIST: "WAITLIST",
    ACCOUNT_CREATED: "ACCOUNT_CREATED"
}

export default CompleteType;